/**
 *
 * @param {number} start
 * @return {Generator<number, void, *>}
 * @constructor
 */
export function* AutoIncrementIdFactory(start = 0) {
  let value = start;

  while (true) {
    yield value++;
  }
}
